import { useState } from "react";
import maisha1 from "../../assets/avatars/maisha-1.webp";
import aariv1  from "../../assets/avatars/aariv-1.webp";

const AVATAR_FIRST = { maisha: maisha1, aariv: aariv1 };
const C0 = "var(--blue)";
const C1 = "#0891b2";

const QUIZ_META = [
  { key: "avgSpelling", label: "Spelling",  icon: "✏️", type: "spelling" },
  { key: "avgMeaning",  label: "Meanings",  icon: "📖", type: "meaning"  },
  { key: "avgSynonym",  label: "Synonyms",  icon: "🔤", type: "synonym"  },
  { key: "avgAntonym",  label: "Antonyms",  icon: "🔄", type: "antonym"  },
];

function quizMeta(type) {
  return QUIZ_META.find(q => q.type === type)
    || (!type || type === "spelling" ? QUIZ_META[0] : { label: type, icon: "📝" });
}

function fmtDate(ts) {
  const d   = new Date(ts);
  const now = new Date();
  const yes = new Date(now); yes.setDate(now.getDate() - 1);
  if (d.toDateString() === now.toDateString()) return "Today";
  if (d.toDateString() === yes.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
}

function PlayerCard({ s, isLeader, color }) {
  const avatarSrc = AVATAR_FIRST[s.child.name.toLowerCase()];
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: ".2rem", textAlign: "center" }}>
      <div style={{ height: 22, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {isLeader && <span style={{ fontSize: "1rem" }}>👑</span>}
      </div>
      {avatarSrc
        ? <img src={avatarSrc} alt={s.child.name} style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover", border: isLeader ? "2.5px solid #f59e0b" : "2px solid var(--border)", boxShadow: isLeader ? "0 0 0 3px rgba(245,158,11,.2)" : "none" }} />
        : <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--surface2)", border: isLeader ? "2.5px solid #f59e0b" : "2px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem" }}>{s.child.avatar}</div>
      }
      <div style={{ fontWeight: 800, fontSize: ".88rem", marginTop: ".15rem" }}>{s.child.name}</div>
      <div style={{ fontWeight: 900, fontSize: "1.75rem", color, lineHeight: 1.1 }}>{s.points}</div>
      <div style={{ fontSize: ".68rem", color: "var(--muted)", fontWeight: 600 }}>points</div>
    </div>
  );
}

export function Leaderboard({ currentUser, data, users }) {
  const children = users.filter(u => u.role === "child");
  const [period, setPeriod] = useState("week");
  const now = Date.now();

  function inPeriod(s) {
    if (period === "week")  return s.date >= now - 7  * 86400000;
    if (period === "month") return s.date >= now - 30 * 86400000;
    return true;
  }

  const stats = children.map(child => {
    const allS  = (data.sessions || []).filter(s => s.userId === child.id);
    const sess  = allS.filter(inPeriod);
    const spell = sess.filter(s => !s.type || (s.type !== "meaning" && s.type !== "synonym" && s.type !== "antonym"));
    const mean  = sess.filter(s => s.type === "meaning");
    const syn   = sess.filter(s => s.type === "synonym");
    const ant   = sess.filter(s => s.type === "antonym");
    const avg   = arr => arr.length ? Math.round(arr.reduce((a, b) => a + b.score, 0) / arr.length) : null;
    const mastered = Object.entries(data.progress || {}).filter(
      ([k, v]) => k.startsWith(child.id) && !k.includes("_meaning_") && !k.includes("_syn_") && !k.includes("_ant_") && v.mastered
    ).length;
    return {
      child,
      points:      data.points?.[child.id]  || 0,
      streak:      data.streaks?.[child.id] || 0,
      badges:      (data.badges?.[child.id] || []).length,
      mastered,
      avgSpelling: avg(spell),
      avgMeaning:  avg(mean),
      avgSynonym:  avg(syn),
      avgAntonym:  avg(ant),
      ptsEarned:   period === "all"
        ? (data.points?.[child.id] || 0)
        : sess.reduce((a, s) => a + (s.ptsEarned || 0), 0),
      testsCount: sess.length,
    };
  });

  const recentSessions = [...(data.sessions || [])]
    .filter(s => children.some(c => c.id === s.userId))
    .sort((a, b) => b.date - a.date)
    .slice(0, 8);

  const isTwoKids = children.length === 2;
  const s0 = stats[0];
  const s1 = stats[1];

  return (
    <div>
      {/* ── Period tabs ─────────────────────────────────────── */}
      <div style={{ display: "flex", gap: ".4rem", marginBottom: "1.25rem" }}>
        {[["week","This Week"],["month","This Month"],["all","All Time"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setPeriod(k)}
            style={{
              padding: ".35rem .85rem", borderRadius: 999, border: "none",
              fontWeight: 700, fontSize: ".78rem", cursor: "pointer", transition: "all .15s",
              background: period === k ? "var(--blue)" : "var(--surface2)",
              color:      period === k ? "#fff"        : "var(--muted)",
            }}>{l}</button>
        ))}
      </div>

      {isTwoKids ? (
        <>
          {/* ── VS Card ─────────────────────────────────────── */}
          <div style={{ borderRadius: 16, background: "var(--surface)", border: "1.5px solid var(--border)", overflow: "hidden", marginBottom: "1rem" }}>
            <div style={{ height: 3, background: "linear-gradient(90deg, var(--blue), #f59e0b, var(--blue))" }} />
            <div style={{ padding: "1rem 1rem .9rem" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", gap: ".5rem", marginBottom: ".85rem" }}>
                <PlayerCard s={s0} isLeader={s0.points >= s1.points} color={C0} />
                <div style={{ textAlign: "center", fontWeight: 900, fontSize: "1.35rem", color: "var(--muted)", letterSpacing: ".04em" }}>VS</div>
                <PlayerCard s={s1} isLeader={s1.points >= s0.points} color={C1} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".5rem" }}>
                {[s0, s1].map((s, i) => (
                  <div key={s.child.id} style={{ background: "var(--surface2)", borderRadius: 10, padding: ".45rem .65rem", fontSize: ".75rem", fontWeight: 700, color: "var(--muted)", textAlign: "center" }}>
                    🔥 {s.child.name} — <span style={{ color: i === 0 ? C0 : C1, fontWeight: 800 }}>{s.streak}</span> day streak
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── Head to Head ────────────────────────────────── */}
          <div className="card" style={{ marginBottom: "1rem" }}>
            <div className="card-title" style={{ marginBottom: ".85rem" }}>⚔️ Head to Head</div>
            {QUIZ_META.map(q => {
              const v0 = s0[q.key];
              const v1 = s1[q.key];
              const w0 = v0 !== null && (v1 === null || v0 > v1);
              const w1 = v1 !== null && (v0 === null || v1 > v0);
              const goldRow = w0 && v0 !== null;
              return (
                <div key={q.key} style={{
                  background: goldRow ? "#fff9e6" : "var(--surface2)",
                  border: `1px solid ${goldRow ? "#fde68a" : "transparent"}`,
                  borderRadius: 10, padding: ".55rem .5rem", marginBottom: ".4rem",
                }}>
                  <div style={{ fontSize: ".72rem", fontWeight: 800, color: "var(--muted)", marginBottom: ".4rem" }}>
                    {q.icon} {q.label}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", gap: ".3rem" }}>
                    {/* Left — child 0 */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: ".3rem", flexWrap: "wrap" }}>
                      {v0 !== null ? (
                        <>
                          {w0 && <span style={{ fontSize: ".8rem" }}>🏅</span>}
                          <span style={{ fontSize: ".78rem", fontWeight: 700, color: C0 }}>{v0}%</span>
                          <div style={{ width: 48, background: "var(--border)", borderRadius: 4, height: 7, overflow: "hidden", flexShrink: 0 }}>
                            <div style={{ width: `${v0}%`, height: "100%", background: C0, borderRadius: 4, marginLeft: "auto" }} />
                          </div>
                          {!w0 && v1 !== null && (
                            <span style={{ fontSize: ".62rem", background: "#fef3c7", color: "#92400e", borderRadius: 99, padding: ".1rem .4rem", fontWeight: 700, whiteSpace: "nowrap" }}>Beat it!</span>
                          )}
                        </>
                      ) : (
                        <span style={{ fontSize: ".63rem", background: "var(--surface)", color: "var(--muted)", border: "1px solid var(--border)", borderRadius: 99, padding: ".1rem .45rem", fontWeight: 600 }}>Not started</span>
                      )}
                    </div>
                    {/* Centre */}
                    <div style={{ fontSize: ".6rem", color: "var(--muted)", fontWeight: 700, padding: "0 .1rem" }}>vs</div>
                    {/* Right — child 1 */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: ".3rem", flexWrap: "wrap" }}>
                      {v1 !== null ? (
                        <>
                          {!w1 && v0 !== null && (
                            <span style={{ fontSize: ".62rem", background: "#fef3c7", color: "#92400e", borderRadius: 99, padding: ".1rem .4rem", fontWeight: 700, whiteSpace: "nowrap" }}>Beat it!</span>
                          )}
                          <div style={{ width: 48, background: "var(--border)", borderRadius: 4, height: 7, overflow: "hidden", flexShrink: 0 }}>
                            <div style={{ width: `${v1}%`, height: "100%", background: C1, borderRadius: 4 }} />
                          </div>
                          <span style={{ fontSize: ".78rem", fontWeight: 700, color: C1 }}>{v1}%</span>
                          {w1 && <span style={{ fontSize: ".8rem" }}>🏅</span>}
                        </>
                      ) : (
                        <span style={{ fontSize: ".63rem", background: "var(--surface)", color: "var(--muted)", border: "1px solid var(--border)", borderRadius: 99, padding: ".1rem .45rem", fontWeight: 600 }}>Not started</span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        /* ── Standard ranked list ───────────────────────────── */
        <div className="card" style={{ marginBottom: "1rem" }}>
          <div className="card-title" style={{ marginBottom: ".85rem" }}>🏅 Leaderboard</div>
          {[...stats].sort((a, b) => b.ptsEarned - a.ptsEarned).map((s, i) => (
            <div key={s.child.id} style={{
              display: "flex", alignItems: "center", gap: ".75rem",
              padding: ".65rem .35rem",
              borderBottom: i < stats.length - 1 ? "1px solid var(--border)" : "none",
              background: i === 0 ? "#fffbeb" : i === 1 ? "#f8fafc" : i === 2 ? "#fdf4f0" : "transparent",
              borderRadius: 8,
            }}>
              <div style={{ fontWeight: 900, fontSize: "1rem", width: 24, textAlign: "center" }}>
                {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}
              </div>
              <div style={{ fontSize: "1.4rem" }}>{s.child.avatar}</div>
              <div style={{ flex: 1, fontWeight: 700, fontSize: ".9rem" }}>
                {s.child.name}
                {s.child.id === currentUser.id && (
                  <span style={{ fontSize: ".6rem", background: "var(--blue)", color: "#fff", borderRadius: 999, padding: ".05rem .35rem", marginLeft: ".4rem" }}>You</span>
                )}
              </div>
              <div style={{ fontWeight: 800, color: "var(--blue)", fontSize: ".9rem" }}>{s.ptsEarned} pts</div>
            </div>
          ))}
        </div>
      )}

      {/* ── Recent Activity ─────────────────────────────────── */}
      <div className="card">
        <div className="card-title" style={{ marginBottom: ".85rem" }}>📋 Recent Activity</div>
        {recentSessions.length === 0 ? (
          <div className="empty-state">No activity yet</div>
        ) : recentSessions.map((s, i) => {
          const child    = children.find(c => c.id === s.userId);
          const childIdx = children.indexOf(child);
          const initial  = child?.name?.[0] || "?";
          const { label: qLabel, icon: qIcon } = quizMeta(s.type);
          return (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: ".6rem",
              padding: ".45rem 0",
              borderBottom: i < recentSessions.length - 1 ? "1px solid var(--border)" : "none",
            }}>
              <span style={{ fontSize: "1rem", flexShrink: 0 }}>{qIcon}</span>
              <span style={{
                fontSize: ".65rem", fontWeight: 800, padding: ".1rem .4rem", borderRadius: 6, flexShrink: 0,
                background: childIdx === 0 ? "#f5f3ff" : "#f0f9ff",
                color:      childIdx === 0 ? "#4f46e5" : "#0891b2",
              }}>{initial}</span>
              <span style={{ flex: 1, fontSize: ".78rem", fontWeight: 600 }}>{qLabel}</span>
              <span style={{ fontSize: ".72rem", color: "var(--muted)", flexShrink: 0 }}>{fmtDate(s.date)}</span>
              <span style={{ fontSize: ".78rem", fontWeight: 700, color: "var(--blue)", minWidth: 34, textAlign: "right" }}>
                {typeof s.score === "number" ? `${s.score}%` : "—"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
